<template>
  <span v-if="validDatesText" v-html="validDatesText"></span>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment';

  export default {
    name: "ValidDates",
    props: ['bounty'],
    data() {
      return {
        dateFormat: 'DD.MM.YYYY HH:mm',
        validDates: {
          set: false,
          valid: false
        },
        validDatesText: ''
      }
    },
    mounted() {
      this.getValidDatesText();
      this.setValidDatesObj();
      this.$emit('isvaliddates', this.validDates);
    },
    computed: {
      validFrom() {
        return _.get(this.bounty, 'valid_from');
      },
      validUntil() {
        return _.get(this.bounty, 'valid_until');
      }
    },
    methods: {
      getValidDatesText() {
        if (!_.isEmpty(this.validFrom) && !_.isEmpty(this.validUntil)) {
          this.validDatesText = this.$t('bounties.ParticipationValidFromUntil', {from: moment(this.validFrom).format(this.dateFormat), until: moment(this.validUntil).format(this.dateFormat)});
        } else if (!_.isEmpty(this.validFrom)) {
          this.validDatesText = this.$t('bounties.ParticipationValidFrom', {from: moment(this.validFrom).format(this.dateFormat)});
        } else if (!_.isEmpty(this.validUntil)) {
          this.validDatesText = this.$t('bounties.ParticipationValidUntil', {until: moment(this.validUntil).format(this.dateFormat)});
        }
      },
      setValidDatesObj() {
        if (!_.isEmpty(this.validFrom) || !_.isEmpty(this.validUntil)) {
          this.validDates.set = true;
        }

        if (!_.isEmpty(this.validFrom) && !_.isEmpty(this.validUntil)) {
          this.validDates.valid = moment(+new Date).isBetween(this.validFrom, this.validUntil);
        } else if (!_.isEmpty(this.validFrom)) {
          this.validDates.valid = moment(+new Date).isSameOrAfter(this.validFrom);
        } else if (!_.isEmpty(this.validUntil)) {
          this.validDates.valid = moment(+new Date).isSameOrBefore(this.validUntil);
        }
      }
    }
  }
</script>
